<template>
    <div>
        <PageHeader type="Beta" title="Smart Music">
            <template #meta>
                Play songs as vocals only or music only. Each song costs us about $0.24 to transform —
                <a href="https://www.buymeacoffee.com/kaym.dev" target="_blank" class="text-white underline underline-offset-2">support us</a>
                to grow the collection.
            </template>
        </PageHeader>
        <TrackList :songs="songs.data || []" :ad-after="[4, 24]" header />
        <nav v-if="songs && (songs.prev_page_url || songs.next_page_url)" class="mt-8 flex items-center justify-between gap-3">
            <Link v-if="songs.prev_page_url" :href="songs.prev_page_url" class="nl-btn-ghost">
                <span class="icon-chevron-left"></span> Previous
            </Link>
            <span v-else></span>
            <Link v-if="songs.next_page_url" :href="songs.next_page_url" class="nl-btn-ghost">
                Next <span class="icon-chevron-right"></span>
            </Link>
        </nav>
    </div>
</template>
<script setup>
import PageHeader from "@/components/ui/PageHeader.vue";
import TrackList from "@/components/ui/TrackList.vue";
import { Link } from "@inertiajs/vue3";
import CardSong from "@/components/CardSong.vue";
defineProps({ songs: Object });
</script>